/**
 * Storage reads that never throw.
 *
 * With site data blocked — a privacy-hardened browser, some in-app browsers, a strict
 * enterprise policy — merely touching `window.localStorage` or `window.sessionStorage`
 * throws a SecurityError. Several theme modules read their saved state when they are
 * imported, before Alpine starts, and one uncaught error there stops the whole theme
 * bundle: Alpine never boots and every component on the page is left dead. Reading
 * through here turns that into "nothing saved", which every caller already handles.
 */

/**
 * Parse a JSON value from storage, or hand back the fallback.
 *
 * @param {string} key
 * @param {*} fallback returned when storage is blocked, the key is absent, or the value
 *   is not valid JSON
 * @param {'local'|'session'} [area]
 * @returns {*}
 */
export function readStoredJson(key, fallback, area = 'local') {
  try {
    const store = area === 'session' ? window.sessionStorage : window.localStorage;
    const raw = store.getItem(key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export default { readStoredJson };
